/**
 * @description 教学，训练和考试模块
 */
import http from '@/service/http'
import {ROOT_SIMULATOR, ROOT_RESOURCE} from './urlConfig'
//获取场景列表
export const getAllSceneByType = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/sceneManage/getSceneListWithUserPermissions',params)
}

//创建新的训练
export const createTraining = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/training/create',params)
}

//删除已有训练
export const deleteTraining = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/training/delete',params)
}

export const getStationSceneDataByStationId = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/sceneManage/getStationSceneDataByStationId',params)
}

//获取资源文件信息
export const getPakSize = (params:object)=>{
    return http.get(ROOT_RESOURCE+'/resource/releaseModelFiles',params)
}

//据成绩ID获取所有动作列表
export const getActionListByScoresId = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/action/getActionListByScoresId',params)
}

//获取航线数据
export const getAirLineDetails = (params:object)=>{
    return http.get(ROOT_SIMULATOR+'/api/airline/getAirLineDetails',params)
}

//获取航线数据
export const getAirLineDetail = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/airline/getAirLineDetail',params)
}

//根据设备ID获取设备详情
export const getUotsDeviceDetail = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/uotsDevice/getUotsDeviceDetail',params)
}

//获取默认训练数据设置
export const getDefaultTrainingSetting = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/user/getDefaultTrainingSetting',params)
}

//上传图片--电子桩图片
export const saveTrainingExData = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/training/saveTrainingExData',params)
}

// 上传图片--曲线图片
export const saveTrainingItemScorePicture = (params:any,config:any)=>{
    return http.post(ROOT_SIMULATOR+'/api/training/saveTrainingItemScorePicture',params)
}

//获取模板训练数据设置
export const getTemplateTrainingSetting = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/user/getTemplateTrainingSetting',params)
}

// 获取当前科目训练所属等级的合格判定配置
export const getScoringItemSetting = (params:object):ReturnType<typeof http.post>=>{
    return http.post(ROOT_SIMULATOR+'/api/training/getScoringItemSetting',params)
}

// 保存当前科目训练所属等级的合格判定配置
export const saveScoringItemSetting = (params:object):ReturnType<typeof http.post>=>{
    return http.post(ROOT_SIMULATOR+'/api/training/saveScoringItemSetting',params)
}
//获取航线数据
export const getAirLineDetailNew = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/airline/getAirLineDetail',params)
}
